/** 曝光模式 */
export const 曝光模式_CDF = 'cdf' as const
export const 曝光模式_CLAHE = 'clahe' as const

/** HSL调整层类型 */
export const HSL类型_全局 = 'global' as const
export const HSL类型_选择性 = 'selective' as const

/** Vue Watch 刷新时机 */
export const 刷新时机_同步 = 'sync' as const
